import { styled } from '@mui/material/styles';
import { DeviceWidth } from '../interfaces/App';

interface VerticalStackProps {
  alignItems?: string;
  flexWrap?: 'wrap' | 'nowrap';
  gap?: string;
  justifyContent?: string;
  marginTop?: string;
  maxWidth?: DeviceWidth | string;
  padding?: string;
}

const VerticalStack = styled('div')<VerticalStackProps>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  flex-wrap: ${({ flexWrap }) => flexWrap || 'nowrap'};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || DeviceWidth.LG};
  padding: ${({ padding }) => padding || '1rem'};
  gap: ${({ gap }) => gap || '3rem'};
  box-sizing: border-box;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${({ padding }) => padding || '2rem'};
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin: ${({ marginTop }) => (marginTop ? `${marginTop} auto` : '0 auto')};
  }

  ${({ theme }) => theme.breakpoints.up('xl')} {
    max-width: ${({ maxWidth }) => maxWidth || DeviceWidth.LG};
  }
`;

export default VerticalStack;
